import { Injectable } from "@angular/core";
import { ApiPath, ApiService, YearMonth } from '@financial/arch';
import { ApportionmentByCostCenter } from '@financial/domain';
import { Observable } from "rxjs";
import { retry } from "rxjs/operators";
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class ApportionmentByCostCenterService {
  private apiPath: ApiPath;

  constructor(api: ApiService) {
    this.apiPath = api.root.path('reports').path('apportionmentByCostCenter');
  }

  findBy(yearMonth: YearMonth): Observable<ApportionmentByCostCenter[]> {
    const params = new HttpParams().append('monthReference', yearMonth.toDefaultString());

    return this.apiPath
      .getJson<ApportionmentByCostCenter[]>({ params: params })
      .pipe(retry(3));
  }
}
